/**
 * Similar to frontends/app/src/util/permissions.ts
 * Modified to align better with Registry permissions
 */
import {IconName} from '@wandb/weave/components/Icon';

import {AccessOption} from '../../../util/permissions';

export type RegistryAccessOptionType = Extract<
  AccessOption,
  AccessOption.Private | AccessOption.Restricted
>;

export function getDisplayNameForRegistryAccess(
  access: RegistryAccessOptionType
): string {
  switch (access) {
    case AccessOption.Restricted:
      return 'Restricted';
    case AccessOption.Private:
      return 'Organization';
  }
}

export function getDescriptionForRegistryAccess(
  access: RegistryAccessOptionType
): string {
  switch (access) {
    case AccessOption.Restricted:
      return 'Only invited members can access this registry. Public sharing is disabled.';
    case AccessOption.Private:
      return `Anyone in the organization can view this registry. You can edit their roles later from the settings`;
  }
}

export function getIconForRegistryAccess(
  access: RegistryAccessOptionType
): IconName {
  switch (access) {
    case AccessOption.Restricted:
      return 'lock-closed';
    case AccessOption.Private:
      return 'lock-open';
  }
}

export function getTooltipTextForRegistryAccess(
  access: RegistryAccessOptionType
): string {
  switch (access) {
    case AccessOption.Restricted:
      return 'Registry access limited to member users';
    case AccessOption.Private:
      return 'Registry visible to all organization members';
  }
}
